var render, staticRenderFns
import script from "./DragContainer.vue?vue&type=script&lang=js"
export * from "./DragContainer.vue?vue&type=script&lang=js"
import style0 from "./DragContainer.vue?vue&type=style&index=0&id=7192f05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7192f05e",
  null
  
)

export default component.exports